/**
 * @Author: Tuire Nissinen
 * @Date:   2025-03-22 14:55:41
 * @Last Modified by:   Tuire Nissinen
 * @Last Modified time: 2025-03-25 18:33:44
 */
import React, { useState } from 'react';

import { render, Fragment } from '@wordpress/element';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';

/**
 * Import the stylesheet for the plugin.
 */
import './style/main.scss';

const Search = () => {

  const stringTranslations = {
    search: searchStringTranslations ? searchStringTranslations.search : 'Search',
    noOptions: searchStringTranslations ? searchStringTranslations.noOptions : 'No options',
    label: searchStringTranslations ? searchStringTranslations.label : 'Label',
  };

  const deleteIcon = (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="ui/circle-times">
      <path id="icon" d="M8 2C4.68548 2 2 4.68548 2 8C2 11.3145 4.68548 14 8 14C11.3145 14 14 11.3145 14 8C14 4.68548 11.3145 2 8 2ZM8 13.2258C5.12823 13.2258 2.77419 10.9008 2.77419 8C2.77419 5.12823 5.09919 2.77419 8 2.77419C10.8718 2.77419 13.2258 5.09919 13.2258 8C13.2258 10.8718 10.9008 13.2258 8 13.2258ZM10.2935 6.32339L8.61694 8L10.2935 9.67661C10.4073 9.79032 10.4073 9.97419 10.2935 10.0879L10.0879 10.2935C9.97419 10.4073 9.79032 10.4073 9.67661 10.2935L8 8.61694L6.32339 10.2935C6.20968 10.4073 6.02581 10.4073 5.9121 10.2935L5.70645 10.0879C5.59274 9.97419 5.59274 9.79032 5.70645 9.67661L7.38306 8L5.70645 6.32339C5.59274 6.20968 5.59274 6.02581 5.70645 5.9121L5.9121 5.70645C6.02581 5.59274 6.20968 5.59274 6.32339 5.70645L8 7.38306L9.67661 5.70645C9.79032 5.59274 9.97419 5.59274 10.0879 5.70645L10.2935 5.9121C10.4048 6.02581 10.4048 6.20968 10.2935 6.32339Z" fill="#323232" />
    </g>
  </svg>
  );

  const arrowIcon = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="ui/angle-bottom">
      <path id="icon" d="M11.7012 14.4936L7.62386 10.353C7.45865 10.1878 7.45865 9.92068 7.62386 9.75548L7.87342 9.50592C8.03862 9.34072 8.30575 9.34072 8.47096 9.50592L12 13.1017L15.529 9.50944C15.6942 9.34423 15.9613 9.34423 16.1265 9.50944L16.3761 9.759C16.5413 9.9242 16.5413 10.1913 16.3761 10.3565L12.2987 14.4971C12.1335 14.6588 11.8664 14.6588 11.7012 14.4936Z" fill="#323232" />
    </g>
  </svg>
  );

  const allowedTags = ['H3', 'H4', 'H5', 'H6']; //, 'DETAILS'
  const [searchValue, setSearchValue] = useState(null);
  const options = [];

  const allElements = document.querySelector('.page-content__content').children; 
  if (!allElements) {
    return;
  }

  for (let element of allElements) {  
    const tagName = element.tagName;
    if (!allowedTags.includes(tagName)) {
      continue;
    }

    if (element.id === '') {
      element.id = element.textContent.toLowerCase().replace(/[^a-z0-9]/g, '-');
    }

    //options.push({name: element.textContent, id: element.id});
    options.push({name: element.textContent, iid: element.id});
  }

  function handleClick() {
    window.location.href = `#${searchValue.iid}`;
  }

  return (
    <Fragment>
      <Autocomplete
        options={options}
        popupIcon={arrowIcon}
        value={searchValue}
        renderTags={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => (
            <Chip
              deleteIcon={deleteIcon} {...getTagProps({ index })} label={option} />
          ));
        }}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}
            >
              {option.name}
            </li>
          );
        }}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name}
        noOptionsText={stringTranslations.noOptions}
        renderInput={(params) => <TextField {...params} label={stringTranslations.label} classes={{ root: "mui-dropdown-overrides-textfield" }} />}
        classes={{ paper: "mui-dropdown-overrides-paper", listbox: 'mui-dropdown-overrides-listbox' }}
        onChange={(event, value) => {setSearchValue(value)}}
      />
      <button onClick={() => handleClick()}>
        {stringTranslations.search}
      </button>
    </Fragment>
   );
}

render(<Search />, document.getElementById('searchBar'));